import { useState, useEffect } from "react";

const navLinks = ["Home", "About", "Products", "Features", "Contact"];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id.toLowerCase());
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="w-full px-6 md:px-12 py-4 flex items-center justify-between">
        <span
          className={`text-xs font-semibold tracking-[0.3em] uppercase transition-colors duration-300 ${
            scrolled ? "text-gray-900" : "text-white/70"
          }`}
        >
          iOS Experts
        </span>

        <div
          className={`text-xl font-bold tracking-[0.2em] uppercase transition-colors duration-300 ${
            scrolled ? "text-gray-900" : "text-white"
          }`}
        >
          MEDEST D.O.O.
        </div>

        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link}
              onClick={() => scrollTo(link)}
              className={`text-xs font-medium tracking-widest uppercase transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-gray-600 hover:text-gray-900"
                  : "text-white/70 hover:text-white"
              }`}
            >
              {link}
            </button>
          ))}
        </div>

        <button
          className={`md:hidden cursor-pointer transition-colors duration-300 ${
            scrolled ? "text-gray-900" : "text-white"
          }`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-sm border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link}
              onClick={() => scrollTo(link)}
              className="text-sm font-medium tracking-widest uppercase text-gray-700 hover:text-gray-900 cursor-pointer text-left whitespace-nowrap"
            >
              {link}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
}
